export class SourceItem {
  public id?: string = '';
  public location: string = '';
  public created_by: string = '';
  public last_updated_by: string = '';
  public created_ts: number = null;
  public last_updated_ts: number = null;
}
